import { ApolloError } from '@apollo/client';
import { ApplicationError, ValidationError } from '.';

export const getApplicationError = (error?: ApolloError) =>
  error?.graphQLErrors?.find((e) => !!e.extensions?.applicationError)?.extensions
    ?.applicationError as ApplicationError | undefined;

export const getValidationErrors = (error?: ApolloError) =>
  error?.graphQLErrors
    ?.filter((e) => !!e.extensions?.validationError)
    ?.map((e) => e.extensions?.validationError) as ValidationError[] | undefined;
